import { create } from 'zustand';
import { Tokens } from '@selfbook/design-tokens-v2';
import { deepMerge, hexToRGBA } from '../../utils';

export const createThemeSlice = (set, get) => ({
  theme: new Tokens(),
  themeOptions: {},
  setTheme: (options) => {
    set({
      theme: new Tokens(options),
      themeOptions: options,
    });
  },
  setThemeColor: (color) => {
    const colorTheme = get().config?.colorTheme || 'light';
    const primaryColor = hexToRGBA(color);
    const colorUpdates = {
      tokens: {
        surface: {
          dark: {
            background: primaryColor,
          },
        },
        text: {
          light: {
            // Should be fixed in Atoms > Button with variant=text does not account for dark mode.
            primary: colorTheme === 'dark' ? 'rgb(255, 255, 255)' : undefined,
          },
        },
      },
      ui: {
        button: {
          ghost: {
            light: {
              active: hexToRGBA(color, 0.24),
              hover: hexToRGBA(color, 0.16),
              skeleton: hexToRGBA(color, 0.04),
            },
          },
          primary: {
            light: {
              bkg: primaryColor,
              disabled: hexToRGBA(color, 0.08),
            },
            dark: {
              text: primaryColor,
              focus: primaryColor,
            },
          },
        },
        calendar: {
          light: {
            arrDepBkgSelected: primaryColor,
            dayBkgActive: hexToRGBA(color, 0.12),
            dayBkgHover: hexToRGBA(color, 0.08),
            dayFocus: primaryColor,
            daySkeleton: hexToRGBA(color, 0.08),
            informativeStroke: primaryColor,
          },
        },
      },
    };

    const mergedOptions = deepMerge(colorUpdates, get().themeOptions || {});
    set({
      theme: new Tokens(mergedOptions),
      themeOptions: mergedOptions,
    });
  },
  setThemeFont: (fontName) => {
    const update = {
      fontFamily: fontName,
    };
    const fontUpdates = {
      tokens: {
        body: {
          expressive: update,
          "compact-expressive": update,
          productive: update,
          "compact-productive": update,
        },
        heading: {
          "compact-01": update,
          "compact-02": update,
          "01": update,
          "02": update,
          "03": update,
          "04": update,
          "05": update,
          "06": update,
          "07": update,
        },
        helper: {
          expressive: update,
          productive: update,
          "xs-productive": update,
        }
      },
    };

    const mergedOptions = deepMerge(fontUpdates, get().themeOptions || {});
    set({
      theme: new Tokens(mergedOptions),
      themeOptions: mergedOptions,
    });
  },
});
